import React, { useEffect, useState } from "react";
import { $API } from "@services/api.service";

interface Props {
  name: string;
}

class State {
  loading = true;
  html = "";
}

export const LoadPolicy = (props: Props) => {
  const [state, setState] = useState<State>(new State());

  useEffect(() => {
    $API.getPolicy(props.name).subscribe((html) => {
      setState((prevState) => ({ ...prevState, loading: false, html }));
    });
  }, [props]);

  if (state.loading) return null;

  return (
    <div
      className={"policy-wrap"}
      dangerouslySetInnerHTML={{ __html: state.html }}
    ></div>
  );
};
